import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: false,
  plugins: [
    createPersistedState({
      key: global.config.endpoint
    })
  ],
  state: {
    lang: null,
    token: null,
    user: null,
    isUserLoggedIn: false,
    localsession: {},
    memory: {},
    config: {},
    pendlang: {}
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      state.isUserLoggedIn = !!token;
    },
    setUser(state, user) {
      state.user = user;
    },
    setSession(state, localsession) {
      state.localsession = localsession;
    },
    setConfig(state, pair) {
      state.config[pair[0]] = pair[1];
    },
    setMemory(state, pair) {
      state.memory[pair[0]] = pair[1];
    },
    setLang(state, lang) {
      state.lang = lang;
    },
    appendLang(state, key) {
      state.pendlang[key] = 1;
    }
  },
  actions: {
    setToken({ commit }, token) {
      commit("setToken", token);
    },
    setUser({ commit }, user) {
      commit("setUser", user);
    },
    setSession({ commit }, localsession) {
      commit("setSession", localsession);
    },
    setConfig({ commit }, pair) {
      commit("setConfig", pair);
    },
    setMemory({ commit }, pair) {
      commit("setMemory", pair);
    },
    setLang({ commit }, lang) {
      commit("setLang", lang);
    },
    appendLang({ commit }, key) {
      commit("appendLang", key);
    }
  }
});
